import {RealGamePlayPendingActionExternalLinkHandler} from "../real-game-play-pending-action.external-link-handler";

export class NetherlandsRealGamePlayPendingActionExternalLinkHandler extends RealGamePlayPendingActionExternalLinkHandler {
    protected get _hideCloseButton(): boolean {
        return true;
    }
}